




























































































import { Component, Vue } from "vue-property-decorator";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import Pdf from "@/components/Pdf.vue";
import FundamentalLetter from "@/views/OWcom/ProFundamental/FundamentalLetter.vue";
import Galery from "@/components/Galery.vue";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Pdf,
    Galery,
    BIcon,
    BIconBoxArrowRight,
    FundamentalLetter,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class CVKeys extends Vue {
  protected galeryLetterSheet: string[] = [
    "/picture_letter/fundamentals_Letter_Keys.png",
    "/picture_letter/fundamentals_Letter_Grid.jpg",
    "/picture_letter/fundamentals_Letter_Spontaneous.png",
    "/picture_letter/fundamentals_Letter_Answer.png",
    "/picture_letter/fundamentals_Letter_Mistakes.png",
  ];

  protected pdfLetter = [
    {
      PdfLink: "/pdf_letter/fundamentals_Letter_Keys.pdf",
      PdfDownload: "10PointsClésLettre",
      TxtPdf: "Fiche 1 : Les 10 points clés ",
    },
    {
      PdfLink: "/pdf_letter/fundamentals_letter_Grid.pdf",
      PdfDownload: "GrilleAnalyseLettre",
      TxtPdf: "Fiche 2 : La grille d’analyse de votre lettre",
    },
    {
      PdfLink: "/pdf_letter/fundamentals_letter_Mistakes.pdf",
      PdfDownload: "ErreursLettre",
      TxtPdf: "Fiche 3 : Les erreurs à éviter",
    },
    {
      PdfLink: "/pdf_letter/fundamentals_letter_Spontaneous.pdf",
      PdfDownload: "lettreSpontanée",
      TxtPdf: "Fiche 4 : Trame lettre spontanée",
    },
    {
      PdfLink: "/pdf_letter/fundamentals_letter_Answer.pdf",
      PdfDownload: "LettreRéponseAnnonce",
      TxtPdf: "Fiche 5 : Trame réponse annonce",
    },
  ];
  protected nxtprevLetterKeys = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail6.png",
    PrevLink: "",
    NextLink: "/Lettre_de_Motivation/Astuces",
  };
}
